import { createSelector } from 'reselect'
import StoreState from 'store/state'

export const settingsSelector = (state: StoreState) => state.settings
export const defaultTimezoneSelector = createSelector(settingsSelector, (settings) => settings.defaults.timezone)
export const timezonesSelector = createSelector(settingsSelector, (settings) => settings.defaults.timezones)
export const teamSelector = createSelector(settingsSelector, (settings) => settings.team)
export const accountSelector = createSelector(settingsSelector, (settings) => settings.account)
